/**
 * Auth service: token storage and refresh token API
 */

const JWT_KEY = 'jwtToken';
const REFRESH_TOKEN_KEY = 'refreshToken';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';

export function getAuthToken() {
  return localStorage.getItem(JWT_KEY);
}

export function getRefreshToken() {
  return localStorage.getItem(REFRESH_TOKEN_KEY);
}

export function setTokens(jwtToken, refreshToken) {
  if (jwtToken != null) {
    localStorage.setItem(JWT_KEY, jwtToken);
  }
  if (refreshToken != null) {
    localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
  }
}

export function clearTokens() {
  localStorage.removeItem(JWT_KEY);
  localStorage.removeItem(REFRESH_TOKEN_KEY);
}

/**
 * Call refresh-token API with current refreshToken.
 * On success: stores new jwtToken and refreshToken, returns new jwtToken.
 * On failure (e.g. 403 Token Revoked): clears tokens and dispatches 'auth:sessionExpired'.
 * @returns {Promise<string>} New jwtToken
 */
export async function refreshAccessToken() {
  const refreshToken = getRefreshToken();
  if (!refreshToken) {
    clearTokens();
    localStorage.removeItem('userData');
    window.dispatchEvent(new CustomEvent('auth:sessionExpired'));
    throw new Error('Access token is no longer valid. Please sign in again.');
  }

  const url = `${API_BASE_URL}/api/v1/refresh-token`;
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ refreshToken }),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    clearTokens();
    localStorage.removeItem('userData');
    window.dispatchEvent(new CustomEvent('auth:sessionExpired'));
    throw new Error(
      errorData.message ||
      'Access token is no longer valid. Please sign in again.'
    );
  }

  const data = await response.json();
  const newJwt = data.jwtToken;
  const newRefresh = data.refreshToken;

  if (newJwt != null) {
    localStorage.setItem(JWT_KEY, newJwt);
  }
  if (newRefresh != null) {
    localStorage.setItem(REFRESH_TOKEN_KEY, newRefresh);
  }

  return newJwt;
}
